<template>
  <div class="service">
    <h3 class="title">全周期服务 陪伴客户成长进化</h3>
    <div class="container">
      <div class="item" v-for="item in datas" :key="item.title">
        <img
          class="item-icon"
          :src="item.icon"
          :alt="item.title"
        />
        <h4 class="item-title">{{item.title}}</h4>
        <p class="item-text">
          {{item.text}}
        </p>
      </div>
      

    </div>
  </div>
</template>

<script>
export default {
  name: "SolutionService",
  
  data() {
    return {
        datas:[
            {
                title:'咨询调研',
                text:'梳理业务流程，聚焦业务痛点，找到持续有效的增长机会和实现路径',
                icon:'https://cdn.ideamake.cn/sw-pc/images/service-01.png'
            },
            {
                title:'工具上线',
                text:'提供产品+内容+硬件+软件为一体的全方位解决方案和全周期的技术实施服务',
                icon:'https://cdn.ideamake.cn/sw-pc/images/service-02.png'
            },
            {
                title:'数据迁移',
                text:'标准化数据迁移及系统打通流程，确保系统平稳迁徙及保障数据安全',
                icon:'https://cdn.ideamake.cn/sw-pc/images/service-03.png'
            },
            {
                title:'价值宣贯',
                text:'价值与场景使用培训，培养使用习惯，提升价值感知',
                icon:'https://cdn.ideamake.cn/sw-pc/images/service-04.png'
            },
            {
                title:'运营支持',
                text:'专属服务团队，提供从标准打法到典型案例等不同维度的运营策略支持',
                icon:'https://cdn.ideamake.cn/sw-pc/images/service-05.png'
            }
        ]
    };
  },
};
</script>

<style lang="scss" scoped>
.service {
  width: 100%;
  height: 100%;
  background: #F7F9FB;
  padding: 80px 0;
  .title {
    font-size: 32px;
    font-weight: 500;
    color: #2d2e30;
    text-align: center;
  }
  .container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 64px;
    .item {
      width: 221px;
      height: 286px;
      background: #ffffff;
      box-shadow: 0px 4px 12px 0px rgba(155, 165, 192, 0.25);
      border-radius: 6px;
      text-align: center;
      padding:16px;
      box-sizing: border-box;
      &-icon {
        width: 48px;
        height: 48px;
        margin-top: 30px;
      }
      &-title {
        font-size: 20px;
        font-weight: 500;
        color: #2d2e30;
        margin-top: 30px;
      }
      &-text {
           margin-top: 30px;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #5a5c60;
        text-align: left;
      }
    }
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>